<template>
  <div class="runtime-graph">
    <highcharts
      class="runtime-chart"
      :options="chartOptions"
    />
  </div>
</template>

<script>
import leadDetailMixin from '@shared/mixins/leadDetailMixin';

export default {
  name: 'RuntimeGraph',
  mixins: [leadDetailMixin],
  computed: {
    chartOptions() {
      return {
        chart: {
          height: 170,
          width: 206,
          type: 'column',
          backgroundColor: 'transparent',
        },
        title: '',
        credits: {
          enabled: false,
        },
        tooltip: {
          style: {
            display: 'none',
          },
        },
        exporting: {
          enabled: false,
        },
        xAxis: {
          categories: ['Alert', 'Expected'],
          lineWidth: 0,
          labels: {
            enabled: true,
            style: {
              textOutline: 0,
              zIndex: 6,
              fontWeight: 'bold',
              fontSize: 8,
              color: 'white',
              fontFamily: 'Gilroy, sans-serif',
            },
          },
        },
        yAxis: [{
          gridLineColor: 'white',
          gridLineDashStyle: 'Dash',
          gridLineWidth: 0,
          title: {
            text: null,
          },
          style: {
            fontFamily: 'Gilroy, sans-serif',
          },
          labels: {
            enabled: false,
          },
          min: 0,
          max: 86400,
        }],
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            width: 10,
          },
          column: {
            grouping: false,
          },
        },
        series: [{
          data: [86400, 86400],
          color: '#2B3757',
          borderWidth: 0,
          pointWidth: 30,
          yAxis: 0,
          xAxis: 0,
          borderRadius: 5,
        }, {
          data: [{
            y: this.runtimeBarGraphData.runtime,
            color: '#FFAB00',
          }, {
            y: 18000,
            color: '#66D383',
          }],
          borderWidth: 0,
          pointWidth: 30,
          yAxis: 0,
          xAxis: 0,
          borderRadius: 5,
        }],
      };
    },
  },
};
</script>

<style lang="scss" scoped>

.runtime-graph {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.runtime-text {
  color: yellow;
}
</style>
